<template>
  <CContainer data-testid="generic-module-form">
    <CRow class="justify-content-center">
      <CCol md="12" class="text-start">
        <CRow>
          <CCol class="d-flex">
            <div class="v3-module-list-title" role="heading" aria-level="2">
              {{ title }}
            </div>
            <HelpCenterButton
              v-if="helpCenterKey"
              classes="ms-2"
              :content-key="helpCenterKey"
            />
            <slot name="titleExtra"></slot>
          </CCol>
          <CCol class="d-flex flex-column align-items-end">
            <CustomSwitch
              type="radio"
              :aria-label="
                title
                  ? `${title}, toggle module on or off`
                  : 'Toggle module on or off'
              "
              :model-value="isActive"
              @change="handleToggle"
            />
            <slot name="switchExtra"></slot>
          </CCol>
        </CRow>
        <p v-if="description" class="v3-module-list-box m-0">
          {{ description }}
        </p>
        <slot name="description"></slot>
        <CAlert
          v-if="responseMessage"
          dismissible
          class="mt-4"
          :color="responseType"
          :show="!!responseMessage"
          role="status"
          aria-live="polite"
          @close="$emit('dismiss-response')"
        >
          {{ responseMessage }}
        </CAlert>
        <slot></slot>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import HelpCenterButton from "@/v3components/HelpCenterButton.vue"
import CustomSwitch from "@/v3components/shared/Form/CustomSwitch.vue"
import { ref, watch } from "vue"

export default {
  name: "GenericModuleForm",
  components: {
    HelpCenterButton,
    CustomSwitch
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    helpCenterKey: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    responseMessage: {
      type: String,
      default: ""
    },
    responseType: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "toggle", "reset-response", "dismiss-response"],
  setup(props, { emit }) {
    const isActive = ref(props.modelValue)

    watch(
      () => props.modelValue,
      (newValue) => {
        isActive.value = newValue
      }
    )

    const handleToggle = (status) => {
      if (props.loading) return

      emit("toggle", status)
    }

    return {
      isActive,
      handleToggle
    }
  }
}
</script>
